import React from "react";
export const ApiContext = React.createContext(null);
export const useApi = ()=>{
    const context = React.useContext(ApiContext);
    if (!context) {
        throw new Error("useApi must be used within an ApiProvider");
    }
    return context;
};
